function updateFAQs(faq_section, selected_category) {
  let faqs = faq_section.querySelectorAll('details.faq');

  faqs.forEach((faq) => {
    faq.classList.remove('active');
    let faq_categories = faq.dataset.categories.split(',');
    faq_categories.forEach((category) => {
      if (category == selected_category) {
        faq.classList.add('active');
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  var faq_sections = document.querySelectorAll('.faq-section');

  faq_sections.forEach((faq_section) => {
    let faq_inputs = faq_section.querySelectorAll('.faq-nav input');

    if (faq_inputs.length > 1) {
      faq_inputs.forEach((input) => {
        input.addEventListener('change', () => {
          if (input.checked) {
            updateFAQs(faq_section, input.value);
          }
        });
      });
    }
  });
});
